import { themeStyle } from '@repo/ui/theming';

export const tooltipIconTheme = {
  color: themeStyle.selectionBlue,
};
